import { render } from "./TemplateListPackItem.vue?vue&type=template&id=fbb75f08&ts=true"
import script from "./TemplateListPackItem.vue?vue&type=script&lang=ts"
export * from "./TemplateListPackItem.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox});
